import { useEffect } from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useSuggestedTemplateNotice } from './hooks/useSuggestedTemplateNotice';

type SuggestedTemplateNoticeProps = {
	onClick: () => void;
};

export function SuggestedTemplateNotice({ onClick }: SuggestedTemplateNoticeProps) {
	const {
		actions: { handleClick, trackSuggestedTemplateBannerView },
	} = useSuggestedTemplateNotice({ onClick });

	useEffect(() => {
		trackSuggestedTemplateBannerView();
	}, [trackSuggestedTemplateBannerView]);

	return (
		<div
			data-qa="update-supporters-suggested-template-notice"
			className="mt-8 flex flex-col gap-4 rounded-lg bg-background-raised p-4 leading-6"
		>
			<div className="flex flex-col">
				<Text fontWeight="bold">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.suggested_template_banner.title" />
				</Text>
				<Text fontWeight="normal">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.suggested_template_banner.body" />
				</Text>
			</div>
			<Link as="button" onClick={() => handleClick()} data-qa="update-supporters-suggested-template-notice-link">
				<Text fontWeight="bold">
					<Translate value="corgi.petition.starter_dashboard_v2.post_an_update.suggested_template_banner.action" />
				</Text>
			</Link>
		</div>
	);
}
